module.exports = __webpack_public_path__ + "static/media/autobook-appt.6f51ed59.svg";